<div [formGroup]="form">
  <div class="section-container" id="pagamento">
    <div class="section-title">
      <mat-icon>payments</mat-icon>
      <span>Pagamento</span>
    </div>
    <div class="row align-items-end mb-3">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Condição de Pagamento</mat-label>
          <input matInput formControlName="condicaoPagamento" placeholder="Ex.: 30 60, 3x, 15 +2x" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        @if (listaCategoria) {
        <app-select-pesquisavel label="Categoria" [control]="$any(form.get('idCategoriaFinanceira'))"
          [offlineList]="listaCategoria" idField="idCategoriaFinanceira" nameField="descricao" [isOptional]="true"
          hint="Selecione...">
        </app-select-pesquisavel>
        }
      </div>
      <!-- Sem mb-3: com align-items-end a margem inferior desalinharia o botão da base dos campos. -->
      <div class="col-12 col-md-4">
        <button type="button" mat-stroked-button class="btn-secondary btn-gerar-parcelas" (click)="gerarParcelas()">
          <mat-icon>auto_awesome_motion</mat-icon>
          Gerar Parcelas
        </button>
      </div>
    </div>

    @if (parcelas.controls.length > 0) {
    <table mat-table [dataSource]="parcelas.controls" formArrayName="parcelas" class="w-100">
      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef>Parcela</th>
        <td mat-cell *matCellDef="let parcela; let i = index" [formGroupName]="i">
          {{ parcela.get('numeroParcela')?.value }}
        </td>
      </ng-container>

      <ng-container matColumnDef="vencimento">
        <th mat-header-cell *matHeaderCellDef>Vencimento</th>
        <td mat-cell *matCellDef="let parcela; let i = index" [formGroupName]="i">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput [matDatepicker]="picker" formControlName="dataVencimento" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef>Valor (R$)</th>
        <td mat-cell *matCellDef="let parcela; let i = index" [formGroupName]="i">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput formControlName="valorParcela" [currencyMask]="dynamicCurrencyMask" />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="remover">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let parcela; let i = index">
          <button type="button" mat-icon-button (click)="removerParcela(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="d-flex justify-content-between align-items-center mt-2">
      <button type="button" mat-button (click)="adicionarParcela()">
        <mat-icon>add</mat-icon> Adicionar parcela
      </button>
      <div>
        Soma das parcelas: <strong>{{ somaParcelas | abnt:'preco':2 }}</strong>
        @if (divergenciaParcelas) {
        <span class="text-danger ms-2">
          <mat-icon class="align-middle" style="font-size:16px">warning</mat-icon>
          Diverge do Valor Líquido ({{ valorLiquido | abnt:'preco':2 }})
        </span>
        }
      </div>
    </div>
    }
  </div>
</div>